interface Error {
  code: number;
  message: string;
}

interface HydraError {
  'hydra:description': string;
}

interface TokenExpiredError {
  message: string;
  redirect_url: string;
}

export class APIError {
  public code: number;
  public message: string = '';
  public redirectUrl?: string;

  constructor(code: number, error: Error | HydraError | TokenExpiredError) {
    this.code = code;
    this.message =
      (error as Error).message || (error as HydraError)['hydra:description'];
    this.redirectUrl = (error as TokenExpiredError).redirect_url;
  }
}
